// Widget: Letzte Aktivität — die letzten 5 Notifications aus dem
// In-App-Feed (Mentions/Assignments/Updates), klickbar zum Sprung.

import { useLocation } from "wouter-preact";
import { Activity } from "lucide-preact";
import { useNotifications } from "../../store/notifications";

export function ActivityWidget(): preact.JSX.Element {
  const notifs = useNotifications();
  const [, setLocation] = useLocation();

  if (notifs.loading)
    return <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">Lädt…</p>;
  const items = notifs.items.slice(0, 5);
  if (items.length === 0)
    return (
      <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">
        Keine neue Aktivität.
      </p>
    );

  return (
    <ul class="flex flex-col gap-1.5 text-sm">
      {items.map((n) => (
        <li key={n.id}>
          <button
            type="button"
            onClick={() => {
              if (n.link) setLocation(n.link);
            }}
            class="w-full flex items-start gap-2 text-left rounded px-1.5 py-1 hover:bg-[color:var(--color-surface-container-low)]"
          >
            <Activity
              size={14}
              class="text-[color:var(--color-on-surface-variant)] shrink-0 mt-0.5"
            />
            <div class="flex-1 min-w-0">
              <p class="truncate text-sm text-[color:var(--color-on-surface)]">
                {n.title}
              </p>
              {n.body && (
                <p class="truncate text-micro text-[color:var(--color-on-surface-variant)]">
                  {n.body}
                </p>
              )}
            </div>
          </button>
        </li>
      ))}
    </ul>
  );
}
